import React, { useEffect, useRef, useState } from "react";
import PageContainer from "../../components/PageContainer";
import {
  CheckOutlined,
  CloseCircleOutlined,
  DownloadOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { Link, useParams, useHistory } from "react-router-dom";
import { Document, Page } from "react-pdf";
import { pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import BottomSheet from "../../components/BottomSheet";
import PageNumber from "./components/PageNumber";
import { GithubPicker } from "react-color";
import { convertXyToPdfPoints, findByXY, getPageXy } from "./utils";
import { getAnnotationFilesService, savePdfFileService } from "./pdfEditor.api";
import Chat from "./components/chat/Chat";
import { Button, message, notification, Spin } from "antd";
import { v4 as uuidv4 } from "uuid";
import pngGreenImageBytes from "./assets/greenLogo.png";
import pngRedImageBytes from "./assets/redLogo.png";
import pngOrangeImageBytes from "./assets/orangeLogo.png";
import { useDispatch } from "react-redux";
import { addBulkMessage, setMessagesLoading } from "../../actions/pdfMessages";
import { downloadWithAxios, errorMessageHandler } from "../../constant/helper";
import { SessionStatus } from "../../constant/Types";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PdfEditor = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const pageContainerRef = useRef();
  const { sessionId, fileId, consultationStatus } = useParams();

  let pdfDataInChat = sessionStorage.getItem(
    `pdfeditor_${sessionId}_${fileId}`
  );

  if (pdfDataInChat) {
    pdfDataInChat = JSON.parse(pdfDataInChat);
  } else {
    history.push("/home");
  }

  const isChatDisabled =
    consultationStatus === SessionStatus.CLOSED ||
    consultationStatus === SessionStatus.CLOSED_BY_ADMIN;

  const [pageNum, setPageNum] = useState(1);
  const [pageEvent, setPageEvent] = useState(null);
  const [loading, setLoading] = useState(false);

  const [colorPicker, setColorPicker] = useState({
    color: "#fff",
    show: false,
  });
  const [url] = useState(decodeURIComponent(pdfDataInChat.pdfUrl));
  const [numPages, setNumPages] = useState(null);
  const [pdfData, setPdfData] = useState([]);
  const [pdf, setPdf] = useState(null);
  const [annotations, setAnnotations] = useState([]);
  const [tempAnnotations, setTempAnnotations] = useState({});
  const [commentsIsOpen, setCommentIsOpen] = useState(false);
  const [annotUuid, setAnnotUuid] = useState(null);
  const [clickHoldOptions, setClickHoldOptions] = useState({
    timeout_id: 0,
    hold_time: 1000,
  });
  const [ShowConfirmModal, setShowConfirmModal] = useState(false);
  const [DLLoading, setDLLoading] = useState(false);

  const touchHoldSensitivityInPixel = 150;
  let touchStartPosition = [0, 0];
  let touchEndPosition = [0, 0];
  let touchStartTime = 0;
  //

  const toggleZoomAble = (zoom) => {
    let viewport = document.querySelector("meta[name=viewport]");
    if (!viewport) {
      // in case there is no view port meta tag creates one and add it to the head
      viewport = document.createElement("meta");
      viewport.name = "viewport";
      document.getElementsByTagName("head")[0].appendChild(viewport);
    }

    const content = zoom
      ? "width=device-width, initial-scale=1.0, user-scalable=yes"
      : "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";
    // this is where the magic happens by changing the vewport meta tag
    viewport.setAttribute("content", content);
  };

  useEffect(() => {
    toggleZoomAble(true);
    return () => {
      toggleZoomAble(false);
    };
  }, []);

  //
  useEffect(() => {
    notification.info({
      duration: 10,
      description:
        "برای افزودن کامنت بر روی فایل pdf بخش مورد نظر را برای چند ثانیه لمس کنید",
    });

    return () => {
      document.body.style.height = `auto`;
    };
  }, []);

  useEffect(() => {
    getCurrentPdfPage();
    // eslint-disable-next-line
  }, [numPages, pageNum]);

  useEffect(() => {
    setLoading(true);

    if (pdf && pdf.numPages && pdf.numPages > 0) {
      setNumPages(pdf.numPages);
    }
  }, [pdf]);

  useEffect(() => {
    if (
      colorPicker.color !== "#fff" &&
      colorPicker.show === false &&
      pageEvent
    ) {
      addAnnotationHandler();
    }
    // eslint-disable-next-line
  }, [colorPicker.show, colorPicker.color, pageEvent]);

  function getCurrentPdfPage() {
    if (numPages && !isNaN(numPages) && numPages > 0 && pdf) {
      let pdfDataTmp = {};
      let annotationDataTmp = {};
      pdf.loadingTask.promise.then(async (pdfDocument) => {
        const index = pageNum - 1;
        await pdfDocument.getPage(pageNum).then(async (currentPage) => {
          await currentPage.getAnnotations().then((res) => {
            annotationDataTmp[index] = res;
          });

          pdfDataTmp[index] = currentPage;
        });

        setPdfData(pdfDataTmp);
        setAnnotations(annotationDataTmp);
        setLoading(false);
      });
    }
  }

  const onDocumentLoadSuccess = (loadedPdf) => {
    setPdf(loadedPdf);
  };

  const onDocumentLoadError = () => {
    message.error("خطا در بارگذاری فایل PDF");
    setLoading(false);
  };

  const onPageClick = async (event) => {
    // the magic happens here
    event.preventDefault();
    event.persist();

    const index = pageNum - 1;

    const pageContainer =
      (await event.currentTarget) || (await event.target.parentNode.parentNode); // get page container html tag

    const currentPage = pdfData[index]; // get current page object

    const coordinations = convertXyToPdfPoints(
      event,
      pageContainer,
      currentPage
    );

    const currentPageAnnotation = annotations[index];

    let annotationIndex = -1;

    if (currentPageAnnotation !== undefined) {
      annotationIndex = findByXY(
        currentPageAnnotation,
        coordinations.x,
        coordinations.y
      );
    }

    let uuid = null;
    let annot = null;

    if (event.target.className === "tmp_annotation") {
      const tmpAnnotationObject = event.target;
      uuid = tmpAnnotationObject.getAttribute("data-reference-hash");

      getAnnotationChatHandler(uuid);

      return;
    }

    if (annotationIndex !== -1) {
      annot = currentPageAnnotation[annotationIndex];

      uuid =
        annot.fieldName && annot.fieldName !== ""
          ? annot.fieldName
          : annot.unsafeUrl;

      getAnnotationChatHandler(uuid);

      return;
    }
  };

  const getAnnotationChatHandler = async (uuid) => {
    setCommentIsOpen(true);

    dispatch(setMessagesLoading(true));

    setAnnotUuid(uuid);

    let files;

    try {
      files = await getAnnotationFilesService(sessionId, uuid);
    } catch (error) {
      message.error(
        "خطایی در دریافت فایل ها پیش آمده است , لطفا مجددا تلاش نمایید"
      );
      console.error(error);
    }

    if (
      files &&
      files.status &&
      files.status === 200 &&
      files.data !== undefined
    ) {
      dispatch(addBulkMessage(files.data));
    } else {
      message.error("مشکلی در دریافت پیام ها پیش امده است");
    }

    dispatch(setMessagesLoading(false));
  };

  const addAnnotationHandler = async () => {
    try {
      const event = pageEvent;

      setLoading(true);

      const uuid = uuidv4();

      const pageContainer =
        event.currentTarget || event.target.parentNode.parentNode; // get page container html tag

      const currentPage = pdfData[pageNum - 1]; // get current page object

      const coordinations = convertXyToPdfPoints(
        event,
        pageContainer,
        currentPage
      );

      let pageX = getPageXy(event).pageX;
      let pageY = getPageXy(event).pageY;

      pageX =
        pageX - pageContainer.getBoundingClientRect().left - window.scrollX; // get x
      pageY = pageY - 60;

      let tempAnnotationHolder = tempAnnotations;

      const index = pageNum - 1;

      if (!tempAnnotationHolder[index]) {
        tempAnnotationHolder[index] = [];
      }

      tempAnnotationHolder[index].push({
        currPage: pageNum,
        referenceHash: uuid,
        x: coordinations.x - 25,
        y: coordinations.y - 25,
        browserX: pageX - 35 / 2,
        browserY: pageY - 35 / 2,
        color: colorPicker.color,
      });

      setTempAnnotations({
        ...tempAnnotationHolder,
      });

      setPageEvent(null);

      setColorPicker({
        ...colorPicker,
        show: false,
        color: "#fff",
      });

      setLoading(false);
    } catch (e) {
      message.error(e.message ? e.message : `لطفا دوباره تلاش کنید`);

      console.error(e);
    }
  };

  const handleColorChangeComplete = (color) => {
    const colorsName = {
      "#A80202": "RED",
      "#E39F0E": "ORANGE",
      "#43756A": "GREEN",
    };

    setColorPicker({
      ...colorPicker,
      color: colorsName[color.hex.toLocaleUpperCase()],
      show: false,
    });
  };

  const showColorPickerHandler = async (event) => {
    if (isChatDisabled) {
      message.error("امکان افزودن کامنت در مشاوره بسته شده وجود ندارد");
      return;
    }

    setPageEvent(event);

    setColorPicker({
      ...colorPicker,
      show: true,
    });
  };

  const clickHold = async (event, pageNumber) => {
    if (event.cancelable) {
      event.preventDefault();
    }

    event.persist();

    if (event.type !== "touchmove") {
      touchStartTime = new Date().getTime();
      setTouchStartPositions(event);
    }

    const index = pageNumber - 1;

    if (
      event.type !== "touchmove" ||
      (event.touches &&
        event.touches.length === 1 &&
        Math.abs(touchEndPosition[0] - touchStartPosition[0]) <
          touchHoldSensitivityInPixel && // if is is not a swipe :)
        Math.abs(touchEndPosition[1] - touchStartPosition[1]) <
          touchHoldSensitivityInPixel)
    ) {
      touchEndPosition = [0, 0];
      touchStartPosition = [0, 0];

      if (
        (event.type === "touchmove" &&
          touchStartTime - new Date().getTime() > clickHoldOptions.hold_time) ||
        event.type !== "touchmove"
      ) {
        const timeout_id = setTimeout(() => {
          showColorPickerHandler(event, index);
        }, clickHoldOptions.hold_time);

        setClickHoldOptions({
          ...clickHoldOptions,
          timeout_id: timeout_id,
        });
      }
    }

    if (event.touches && event.touches.length > 1) {
      clickHoldOptions.timeout_id && clearTimeout(clickHoldOptions.timeout_id);
    }
  };

  const cancelTouchStartAction = () => {
    clearTimeout(clickHoldOptions.timeout_id);
  };

  function setTouchEndPositions(e) {
    if (e && e.changedTouches && e.changedTouches[0]) {
      touchStartPosition[0] = e.changedTouches[0].clientX
        ? e.changedTouches[0].clientX
        : 0;
      touchStartPosition[1] = e.changedTouches[0].clientY
        ? e.changedTouches[0].clientY
        : 0;
    }
  }

  function setTouchStartPositions(e) {
    if (e && e.touches && e.touches[0]) {
      touchStartPosition[0] = e.touches[0].clientX ? e.touches[0].clientX : 0;
      touchStartPosition[1] = e.touches[0].clientY ? e.touches[0].clientY : 0;
    }
  }

  const clickUnHold = async (event) => {
    if (event.cancelable) {
      event.preventDefault();
    }

    event.persist();

    setTouchEndPositions(event);

    if (
      event.touches &&
      event.touches.length === 1 &&
      Math.abs(touchEndPosition[0] - touchStartPosition[0]) >
        touchHoldSensitivityInPixel && // if is is not a swipe :)
      Math.abs(touchEndPosition[1] - touchStartPosition[1]) >
        touchHoldSensitivityInPixel // if is is not a swipe :)
    ) {
      resetTouchMove();
    }

    if (event.type !== "touchmove") {
      resetTouchMove();
      onPageClick(event);
    }
  };

  function resetTouchMove() {
    touchEndPosition = [0, 0];
    touchStartPosition = [0, 0];
    touchStartTime = 0;
    clearTimeout(clickHoldOptions.timeout_id);
  }

  function closeChatHandler() {
    setCommentIsOpen(false);
    dispatch(addBulkMessage([]));
    setAnnotUuid(null);
  }

  function sendPdfToChat() {
    if (isChatDisabled) {
      history.goBack();
      return;
    }

    let annotationServiceArray = [];

    Object.entries(tempAnnotations).forEach(([index, element]) => {
      annotationServiceArray = annotationServiceArray.concat(element);
    });

    try {
      const cloudFileId = (new URL(url)).pathname.split("/").pop();
      // const cloudFileId = url.split(".com/")[1].split("?")[0];
      setLoading(true);
      savePdfFileService(cloudFileId, sessionId, annotationServiceArray)
        .then((r) => {
          message.success("فایل PDF با موفقیت ارسال شد");
          history.push(pdfDataInChat.backUrl);
        })
        .catch((e) => {
          console.error(e);
          message.error(errorMessageHandler(e));
        })
        .finally(() => setLoading(false));
    } catch (e) {
      console.error(e);
      message.error("خطا در پردازش فایل PDF");
    }
  }

  function changePage(e, dir) {
    setLoading(true);
    if (dir === "next") {
      setPageNum(pageNum + 1);
    } else if (dir === "prev") {
      setPageNum(pageNum - 1);
    }
  }
  return (
    <PageContainer
      pageContainerRef={pageContainerRef}
      classNames="pdf-editor"
      headerProps={{
        content: "ویرایشگر PDF",
        className: "pdf-editor-header pos-fix",
        left: (
          <Link to={pdfDataInChat.backUrl}>
            <LeftOutlined
              style={{
                color: "white",
              }}
            />
          </Link>
        ),
        right: (
          <div
            // className="submit_pdf"
            onClick={() => {
              downloadWithAxios(url, `${Date.now()}.pdf`, setDLLoading);
            }}
          >
            {DLLoading ? (
              <Spin />
            ) : (
              <DownloadOutlined
                style={{
                  fontSize: 22,
                }}
              />
            )}
          </div>
        ),
      }}
      loading={loading}
    >
      <PageNumber pageNumber={pageNum} numPages={numPages} />
      <BottomSheet
        isOpen={ShowConfirmModal}
        setClose={() => setShowConfirmModal(false)}
        viewerClassName="  plus-button-wrapper"
      >
        <div className="confirm-wrapper">
          <div style={{ textAlign: "center" }}>
            <h3> آیا فایل pdf مورد تایید شما است؟ </h3>
            <h4>در صورت تایید فایل ارسال میشود.</h4>
            <Button
              style={{ margin: 10 }}
              shape={"round"}
              onClick={() => setShowConfirmModal(false)}
            >
              لغو
            </Button>
            <Button
              style={{ margin: 10 }}
              type={"secondary"}
              shape={"round"}
              onClick={sendPdfToChat}
            >
              تائید
            </Button>
          </div>
        </div>
      </BottomSheet>

      <div className={"pdf-footer"}>
        <div className="submit_pdf" onClick={() => setShowConfirmModal(true)}>
          <span>تایید</span>
          <CheckOutlined />
        </div>

        <div className={"button-pdf-page"}>
          <div
            className={`change_page next ${pageNum === numPages && "disabled"}`}
            onClick={(e) => {
              pageNum !== numPages && changePage(e, "next");
            }}
          >
            <RightOutlined />
          </div>

          <div
            className={`change_page prev ${pageNum === 1 && "disabled"}`}
            onClick={(e) => {
              pageNum !== 1 && changePage(e, "prev");
            }}
          >
            <LeftOutlined />
          </div>
        </div>
      </div>
      <Document
        file={url}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={onDocumentLoadError}
      >
        {pageContainerRef.current && numPages !== null && (
          <div
            key={pageNum}
            className={`single_page`}
            id={`single_page`}
            data-page-num={pageNum}
            onClick={(e) => {
              onPageClick(e);
            }}
            onMouseDown={(e) => {
              clickHold(e);
            }}
            onMouseUp={clickUnHold}
            onTouchStart={(e) => {
              clickHold(e);
            }}
            onTouchEnd={(e) => {
              clickUnHold(e);
            }}
            onTouchMove={(e) => {
              cancelTouchStartAction();
              clickHold(e);
            }}
          >
            {tempAnnotations &&
              tempAnnotations[pageNum - 1] &&
              tempAnnotations[pageNum - 1].length > 0 && (
                <>
                  {tempAnnotations[pageNum - 1].map((tempAnnotation) => {
                    return (
                      <img
                        key={tempAnnotation.referenceHash}
                        src={
                          tempAnnotation.color.toLocaleUpperCase() === "GREEN"
                            ? pngGreenImageBytes
                            : tempAnnotation.color.toLocaleUpperCase() === "RED"
                            ? pngRedImageBytes
                            : pngOrangeImageBytes
                        }
                        alt="tmp_annotation"
                        className="tmp_annotation"
                        data-reference-hash={tempAnnotation.referenceHash}
                        style={{
                          top: tempAnnotation.browserY,
                          left: tempAnnotation.browserX,
                        }}
                      />
                    );
                  })}
                </>
              )}

            <Page
              loading=""
              onRenderSuccess={() => {
                setLoading(false);
              }}
              pageNumber={pageNum}
              width={pageContainerRef.current.clientWidth}
            />
          </div>
        )}
      </Document>

      {colorPicker.show && (
        <div className="color-picker-container">
          <CloseCircleOutlined
            className={`pdf-color-picker-dismiss`}
            onClick={() => {
              setColorPicker({
                ...colorPicker,
                show: false,
                color: "#fff",
              });
            }}
          />
          <small>
            با توجه به اولویت کامنت یکی از رنگ های زیر را انتخاب نمایید{" "}
          </small>
          <GithubPicker
            color={colorPicker.color}
            colors={["#A80202", "#E39F0E", "#43756A"]}
            onChangeComplete={handleColorChangeComplete}
          />
        </div>
      )}

      <BottomSheet
        isOpen={commentsIsOpen}
        classNames="pdfeditor-popup"
        viewerClassName="pdfeditor-popup-viewer right-text"
        height={3000}
        setClose={closeChatHandler}
      >
        <Chat
          sessionId={sessionId}
          uuid={annotUuid}
          consultationStatus={consultationStatus}
        />
      </BottomSheet>
    </PageContainer>
  );
};

export default PdfEditor;
